var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.855469C18.8049 0.855469 21.5605 1.59283 23.9906 2.99363C26.4206 4.39442 28.4398 6.40943 29.8455 8.83664C31.2513 11.2638 31.9942 14.0179 32 16.8228C32.0057 19.6277 31.2739 22.3848 29.8781 24.8178L26.4765 22.8662C27.5302 21.0296 28.0826 18.9482 28.0783 16.8308C28.074 14.7134 27.5131 12.6344 26.4519 10.8021C25.3907 8.96982 23.8665 7.4487 22.032 6.39125C20.1976 5.3338 18.1174 4.77717 16 4.77717V0.855469Z",
    fill: "#307FE2"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress1);
export default __webpack_public_path__ + "static/media/progress_1.571b737b5a272793217ad87047fd7371.svg";
export { ForwardRef as ReactComponent };